export default "__VITE_ASSET__fa1cf35c__"